import { api } from "./api";

/** Convert base64 URL-safe key to Uint8Array (for applicationServerKey) */
function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, "+")
        .replace(/_/g, "/");
    const raw = window.atob(base64);
    const arr = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
    return arr;
}

export const pushSupported = () =>
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window;

export async function getPushRegistration() {
    if (!("serviceWorker" in navigator)) return null;
    return navigator.serviceWorker.ready;
}

export async function isSubscribedFor(productHandle) {
    if (!pushSupported()) return false;
    const reg = await getPushRegistration();
    const sub = await reg?.pushManager.getSubscription();
    if (!sub) return false;
    // Local flag by handle
    const key = `desashop_push_${productHandle}`;
    return localStorage.getItem(key) === "1";
}

export async function subscribeToProduct({ productHandle, productTitle, email }) {
    if (!pushSupported()) {
        throw new Error("Push non supportate su questo browser");
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        throw new Error("Permesso notifiche negato");
    }

    const { data: vapid } = await api.get("/push/vapid-public-key");
    if (!vapid.key) throw new Error("VAPID non configurato");

    const reg = await getPushRegistration();
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapid.key),
        });
    }

    const json = sub.toJSON();
    await api.post("/push/subscribe", {
        endpoint: json.endpoint,
        keys: json.keys,
        product_handle: productHandle,
        product_title: productTitle,
        email: email || null,
    });

    localStorage.setItem(`desashop_push_${productHandle}`, "1");
    return true;
}

export async function unsubscribeFromProduct(productHandle) {
    const reg = await getPushRegistration();
    const sub = await reg?.pushManager.getSubscription();
    if (sub) {
        await api
            .post("/push/unsubscribe", {
                endpoint: sub.endpoint,
                product_handle: productHandle,
            })
            .catch(() => {});
    }
    localStorage.removeItem(`desashop_push_${productHandle}`);
    return true;
}
